import TransactionTab from "../components/transactionList/TransactionTab.jsx";
import Helmet from "react-helmet";
export default function TransactionPage() {
  return (
    <>
      <Helmet>
        <title>داشبورد</title>
      </Helmet>
      <TransactionTab />
    </>
  );
}
